// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-confirmed {
  color: green !important;
}

.status-cancelled {
  color: red !important;
}

.status-scheduled {
  color: orange !important;
}
.limit_caracters {
  max-width: 200px; /* limite visual */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  cursor: default; /* cursor comum */
}

.comment-text {
  font-style: italic;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}
.procedure-meta span {
  display: block;
  margin-top: 2px;
}

.scheduled-procedures {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #ddd;
}

.scheduled-procedures li {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  border-bottom: 1px solid #eee;
}

.scheduled-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
}

.scheduled-doctor {
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 6px;
}

.scheduled-total {
  margin-top: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-top: 1px solid #ddd;
  font-size: 15px;
  background-color: #f9f9f9;
}

.scheduled-procedure-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/scheduledProceduresModal.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB,EAAE,kBAAkB;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe,EAAE,iBAAiB;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".status-confirmed {\n  color: green !important;\n}\n\n.status-cancelled {\n  color: red !important;\n}\n\n.status-scheduled {\n  color: orange !important;\n}\n.limit_caracters {\n  max-width: 200px; /* limite visual */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: default; /* cursor comum */\n}\n\n.comment-text {\n  font-style: italic;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n.procedure-meta span {\n  display: block;\n  margin-top: 2px;\n}\n\n.scheduled-procedures {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid #ddd;\n}\n\n.scheduled-procedures li {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.scheduled-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  font-size: 14px;\n}\n\n.scheduled-doctor {\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: #333;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.scheduled-total {\n  margin-top: 16px;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  border-top: 1px solid #ddd;\n  font-size: 15px;\n  background-color: #f9f9f9;\n}\n\n.scheduled-procedure-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
